import { render, staticRenderFns } from "./ExcerptImage.vue?vue&type=template&id=03798138&"
import script from "./ExcerptImage.vue?vue&type=script&lang=js&"
export * from "./ExcerptImage.vue?vue&type=script&lang=js&"
import style0 from "./ExcerptImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VDialog,VImg,VSkeletonLoader})
